import styled from 'styled-components';

export const TabContentInner = styled.div`
  border-top: 1px solid #e1e7ee;
  padding: 2em;
  width: 100%;
  color: black;
`;
